import FileUploadModal from './FileUploadModal';
import './FileUploadModal.scss';

export default FileUploadModal;
